/* ===========================================================================
   BB ADD-ONS — smarter "popular picks" on step 2 + the sidebar (2026-10-27)
   ---------------------------------------------------------------------------
   Before: the first 12 products of the Cart Add-ons collection, in collection
   order, minus sold-out / already-in-box / doesn't-fit. Same four every time,
   no relation to what the shopper picked.

   Now (Moshe, Oct 27) the picks are built from the whole builder catalog:
     1. PAIRINGS  — "Pairs Well With" of the items in the box
     2. OCCASION  — items tagged with the shopper's occasion: the landing-page
                    occasion (?occasion=), else the Occasion filter, else
                    inferred when 2+ items in the box share an occasion tag
     3. BESTSELLERS — items tagged bab:bestseller
     4. CART ADD-ONS — the collection from the section setting, as before
   De-duped in that order; within each layer bestsellers come first. Items in
   the box, boxes, cards and sold-out items are never shown. Only items UNDER
   $15; if that leaves fewer than 4, the cap relaxes to $25. Step 2 shows up
   to 8, the sidebar "Keep going" list shows the first 3 of the same list.

   Phones only: the step 2 picks stay hidden until a box is picked (class
   has-box on .bb-step-shell, styled in assets/bb-mobile-compact.css) and
   the heading reads "Add a little extra".

   How it hooks in: box-builder.js's renderUpsells() reads
   BBConfig.upsells.step2 / .sidebar on every shell render, so this file
   rewrites those two arrays right before each render (wrapping
   BBShell.render) and keeps the originals as the fallback layer. Remove
   its entries in snippets/bb-assets.liquid to go back to the plain list.
   =========================================================================== */
(function () {
  "use strict";
  if (window.__bbAddons) return;
  window.__bbAddons = true;

  var CAP = 1500;        /* cents: under $15 */
  var RELAX_CAP = 2500;  /* used when the $15 list has fewer than MIN */
  var MIN = 4;
  var LIMIT = 8;
  var PHONE = "(max-width: 799px)";
  var PHONE_HEADING = "Add a little extra";

  var original = null; /* { step2: [], sidebar: [] } as the theme rendered them */

  function cfg() { return window.BBConfig || {}; }

  function handle(s) {
    return String(s || "").toLowerCase().replace(/&amp;/g, "and").replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }

  function tagsOf(p) { return (p && p.tags) || []; }

  function occasionTags(p) {
    var out = [];
    tagsOf(p).forEach(function (t) {
      var s = String(t);
      var i = s.indexOf("::");
      if (i > -1 && s.slice(0, i).trim().toLowerCase() === "occasion") out.push(handle(s.slice(i + 2)));
    });
    return out;
  }

  function isBestseller(p) {
    return tagsOf(p).some(function (t) { return String(t).toLowerCase() === "bab:bestseller"; });
  }

  function sameOccasion(a, b) {
    /* "get-well" matches "get-well-soon"; "birthday" matches "birthday" */
    if (!a || !b) return false;
    return a === b || a.indexOf(b) === 0 || b.indexOf(a) === 0;
  }

  /* The occasion signal, as a handle, or "" */
  function currentOccasion(state) {
    if (state && state.occasion) return handle(String(state.occasion).replace(/^occasion::/i, ""));
    var sel = document.querySelector('[data-bb-filter="occasion"]');
    if (sel && sel.value) return handle(String(sel.value).replace(/^occasion::/i, ""));
    /* Infer: 2+ items in the box share an occasion tag */
    var counts = {};
    var items = (state && state.items) || {};
    Object.keys(items).forEach(function (k) {
      var p = window.BBCatalog && window.BBCatalog.find(items[k].variantId);
      var seen = {};
      occasionTags(p).forEach(function (o) {
        if (seen[o]) return;
        seen[o] = true;
        counts[o] = (counts[o] || 0) + 1;
      });
    });
    var best = "", n = 0;
    Object.keys(counts).forEach(function (o) { if (counts[o] > n) { n = counts[o]; best = o; } });
    return n >= 2 ? best : "";
  }

  function poolItem(variantId) {
    var pool = (window.BBCatalog && window.BBCatalog.all) || [];
    var id = String(variantId);
    for (var i = 0; i < pool.length; i++) {
      var p = pool[i];
      if (p && String(p.variantId) === id) return p;
    }
    return null;
  }

  function excludedIds(state) {
    var ex = {};
    var c = cfg();
    Object.keys(c.boxes || {}).forEach(function (k) {
      (c.boxes[k] || []).forEach(function (p) {
        if (p) ex[String(p.variantId)] = true;
        ((p && p.variants) || []).forEach(function (v) { ex[String(v.id)] = true; });
      });
    });
    (c.cards || []).forEach(function (p) { if (p) ex[String(p.variantId)] = true; });
    Object.keys((state && state.items) || {}).forEach(function (k) { ex[k] = true; });
    return ex;
  }

  function build(state) {
    var pool = (window.BBCatalog && window.BBCatalog.all) || [];
    var ex = excludedIds(state);
    var seen = {};
    var layers = [[], [], [], []];

    function take(layer, p) {
      if (!p || p.available === false) return;
      var id = String(p.variantId);
      if (!id || ex[id] || seen[id]) return;
      seen[id] = true;
      layers[layer].push(p);
    }

    /* 1. pairings of the items in the box */
    Object.keys((state && state.items) || {}).forEach(function (k) {
      var p = window.BBCatalog && window.BBCatalog.find(state.items[k].variantId);
      ((p && p.pairsWith) || []).forEach(function (pair) {
        take(0, poolItem(pair.variantId) || pair);
      });
    });

    /* 2. occasion */
    var occ = currentOccasion(state);
    if (occ) {
      pool.forEach(function (p) {
        if (occasionTags(p).some(function (o) { return sameOccasion(o, occ); })) take(1, p);
      });
    }

    /* 3. bestsellers */
    pool.forEach(function (p) { if (isBestseller(p)) take(2, p); });

    /* 4. the Cart Add-ons collection (the old list), then the sidebar one */
    ((original && original.step2) || []).forEach(function (p) { take(3, p); });
    ((original && original.sidebar) || []).forEach(function (p) { take(3, p); });

    /* bestsellers first inside each layer (stable) */
    layers.forEach(function (list) {
      list.sort(function (a, b) { return (isBestseller(b) ? 1 : 0) - (isBestseller(a) ? 1 : 0); });
    });
    var all = [].concat(layers[0], layers[1], layers[2], layers[3]);

    var cheap = all.filter(function (p) { return Number(p.price) < CAP; });
    var list = cheap.length >= MIN ? cheap : all.filter(function (p) { return Number(p.price) < RELAX_CAP; });
    if (list.length < MIN) list = all;
    return list.slice(0, LIMIT);
  }

  function phone() { return window.matchMedia(PHONE).matches; }

  function syncStep2Chrome(state) {
    var shell = document.querySelector('[data-bb-panel="2"] .bb-step-shell');
    if (shell) shell.classList.toggle("has-box", !!(state && state.box && state.box.variantId));
    var title = document.querySelector("[data-bb-step2-upsell] .bb-step-upsell__title");
    if (title) {
      if (!title.getAttribute("data-bb-desktop-text")) title.setAttribute("data-bb-desktop-text", title.textContent);
      var want = phone() ? PHONE_HEADING : title.getAttribute("data-bb-desktop-text");
      if (title.textContent !== want) title.textContent = want;
    }
  }

  function patch() {
    if (!window.BBShell || typeof window.BBShell.render !== "function" || window.BBShell.__addons) return !!(window.BBShell && window.BBShell.__addons);
    if (!window.BBStore || !window.BBCatalog) return false;
    var c = cfg();
    c.upsells = c.upsells || {};
    original = { step2: (c.upsells.step2 || []).slice(), sidebar: (c.upsells.sidebar || []).slice() };

    var origRender = window.BBShell.render;
    window.BBShell.render = function () {
      try {
        var state = window.BBStore.get();
        var picks = build(state);
        cfg().upsells.step2 = picks;
        cfg().upsells.sidebar = picks;
        syncStep2Chrome(state);
      } catch (e) {
        if (window.console) console.warn("[BB] add-on picks fell back", e);
      }
      return origRender.apply(this, arguments);
    };
    window.BBShell.__addons = true;

    var mq = window.matchMedia(PHONE);
    var onChange = function () { try { syncStep2Chrome(window.BBStore.get()); } catch (e) {} };
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else if (mq.addListener) mq.addListener(onChange);
    /* The Occasion filter isn't in the state; re-pick when it changes. */
    document.addEventListener("change", function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-bb-filter="occasion"]')) {
        try { window.BBShell.render(); } catch (e) {}
      }
    });

    try { window.BBShell.render(); } catch (e) {}
    return true;
  }

  if (!patch()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (patch() || ++tries > 200) clearInterval(iv);
    }, 50);
  }
})();
